import { render, staticRenderFns } from "./ContractASorList.vue?vue&type=template&id=3070595a"
import script from "./ContractASorList.vue?vue&type=script&lang=js"
export * from "./ContractASorList.vue?vue&type=script&lang=js"
import style0 from "./ContractASorList.vue?vue&type=style&index=0&id=3070595a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports